import { useEffect } from 'react';

export const WEPAY_CHECKOUT_COMPLETE = 'WEPAY_CHECKOUT_COMPLETE';

const WepayPaymentCallback = () => {
  useEffect(() => {
    const shouldCloseCheckout = new URLSearchParams(window.location.search).get('closeCheckout') === 'true';

    if (shouldCloseCheckout && window.parent !== window) {
      window.parent.postMessage({ type: WEPAY_CHECKOUT_COMPLETE }, window.location.origin);
    }
  }, []);

  return null;
};

export default WepayPaymentCallback;
